/**
 * Completion Checklist can be one per whole form.
 * It's expected to override this component via context because by itself it has no data to show.
 */
export const BlockCompletionChecklist = (props) => {
    throw new Error("BlockCompletionChecklist must be overridden via BlockComponentContext where the specific checklist data to be displayed must be defined.");
};
